import React from 'react';
import WorkerRutSearch from '../../components/WorkerRutSearch';

export default function ClientDashboard() {
  return (
    <div className="space-y-6 animate-fade-in" data-testid="client-dashboard">
      <div>
        <h1 className="text-2xl font-bold text-[#2B4B8C]">Dashboard Mandante</h1>
        <p className="text-[#2B4B8C]/60">Panel de control</p>
      </div>
      <WorkerRutSearch />
    </div>
  );
}
